// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hasClaimWarning .v-messages__message,.lossDateWarning .v-messages__message{color:#ff5252!important}", ""]);
// Exports
module.exports = exports;
